import script from "./AdminPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPortal.vue?vue&type=script&setup=true&lang=js"

import "./AdminPortal.vue?vue&type=style&index=0&id=5f05caf5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f05caf5"]])

export default __exports__